import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { formatNumber } from "../modules";
import { deepPurple, grey, red } from "@mui/material/colors";
import { notiError } from "../../utils/notiUltils";

const VerticalBar = ({ value = 0, status }) => {
  return (
    <Box
      borderRadius={4}
      height={"48px"}
      width={"7%"}
      bgcolor={grey[500]}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"end"}
      overflow={'hidden'}
      className={status ? "animate__animated animate__bounceIn" : ""}
    >
      <Box
        borderRadius={4}
        //width={'100%'}
        height={value + "%"}
        bgcolor={value >= 50 ? deepPurple["A200"] : red["A200"]}
      />
    </Box>
  );
};

function DailyEvent({ api, eventReal }) {
  const [dataSource, setDataSource] = useState([0]);
  const [dataMax, setDataMax] = useState(0);
  const [status, setStatus] = useState(false);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }
    api
      .get("/dashboard8", localStorage.getItem("token"))
      .then((data) => {
        setDataSource(data);
        setTotal(data[0] ?? 0);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, [api]);

  useEffect(() => {
    setDataMax(Math.max(...dataSource) ?? 0);
  }, [dataSource]);

  useEffect(() => {
    if (!eventReal) {
      return;
    }
    setDataSource((old) => {
      const tmp = [...old];
      tmp[0] = tmp[0] + 1;
      return tmp;
    });
    setStatus(false);
    setTimeout(() => {
      setTotal((old) => (old += 1));
      setStatus(true);
    }, 100);
  }, [eventReal]);

  return (
    <Card
      sx={{
        minHeight: 188,
        height: "100%",
        p: 1,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        className={status ? "animate__animated animate__flipInX" : ""}
        title={formatNumber(total)}
        sx={{ pb: 0.8 }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack
          direction="row"
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <VerticalBar
            value={
              dataSource[4] === dataMax ? 100 : (dataSource[4] * 100) / dataMax
            }
          />
          <VerticalBar
            value={
              dataSource[3] === dataMax ? 100 : (dataSource[3] * 100) / dataMax
            }
          />
          <VerticalBar
            value={
              dataSource[2] === dataMax ? 100 : (dataSource[2] * 100) / dataMax
            }
          />
          <VerticalBar
            value={
              dataSource[1] === dataMax ? 100 : (dataSource[1] * 100) / dataMax
            }
          />

          <VerticalBar
            value={
              dataSource[0] === dataMax ? 100 : (dataSource[0] * 100) / dataMax
            }
            status={status}
          />
        </Stack>
      </CardContent>
      <CardActions sx={{ justifyContent: "center" }}>
        <Typography color="text.secondary" variant="body2">
          เหตุการณ์พื้นที่รายวัน
        </Typography>
      </CardActions>
    </Card>
  );
}

export default DailyEvent;
